module.exports = __webpack_public_path__ + "prod/20260430154405/img/service.edbff227.png";